// Every VITE_* variable is read here and nowhere else, so a missing or renamed one fails in one place.
const raw = import.meta.env

function withDefault(value: string | undefined, fallback: string): string {
  return value && value.length > 0 ? value : fallback
}

export const env = {
  /** Backend origin without a trailing slash, e.g. https://api.leazepro.com */
  apiBaseUrl: withDefault(raw.VITE_API_BASE_URL, 'http://localhost:3000').replace(/\/+$/, ''),
  /** CloudFront host that serves S3 media keys (avatars, banners, documents). */
  mediaHost: withDefault(raw.VITE_MEDIA_HOST, '').replace(/\/+$/, ''),
  appUrl: withDefault(raw.VITE_APP_URL, typeof window === 'undefined' ? '' : window.location.origin),
  marketingUrl: withDefault(raw.VITE_MARKETING_URL, 'https://www.leazepro.com').replace(/\/+$/, ''),
  termsUrl: withDefault(raw.VITE_TERMS_URL, 'https://www.leazepro.com/terms'),
  privacyUrl: withDefault(raw.VITE_PRIVACY_URL, 'https://www.leazepro.com/privacy'),
  appStoreUrl: withDefault(raw.VITE_APP_STORE_URL, 'https://apps.apple.com/in/app/leazepro/id6761068749'),
  playStoreUrl: withDefault(raw.VITE_PLAY_STORE_URL, 'https://play.google.com/store/apps/details?id=com.leazepro.app&hl=en_IN'),
  /** Google Maps key for address autocomplete (Places). Empty = manual address entry only. */
  googleMapsApiKey: withDefault(raw.VITE_GOOGLE_MAPS_API_KEY, ''),
  /** Sentry DSN; empty = monitoring off (dev, previews). */
  sentryDsn: withDefault(raw.VITE_SENTRY_DSN, ''),
  /** Google Analytics 4 measurement id (G-…); empty = events only go to the dev console. */
  analyticsId: withDefault(raw.VITE_ANALYTICS_ID, ''),
  /** 'production' | 'staging' | 'development' — tags errors and events. */
  appEnv: withDefault(raw.VITE_APP_ENV, raw.DEV ? 'development' : 'production'),
  /** Paddle.js client-side token for the /pay page, which Paddle links to with only a transaction id (LP-514).
   *  Public by design. Checkouts started in the app use the token their initiate response carries. */
  paddleClientToken: withDefault(raw.VITE_PADDLE_CLIENT_TOKEN, ''),
  /** 'sandbox' | 'production' — must match the token. */
  paddleEnvironment: withDefault(raw.VITE_PADDLE_ENV, 'production') as 'sandbox' | 'production',
  isDev: raw.DEV,
} as const
